import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePreloaderStore = defineStore('preloader', () => {
  const activeLoaders = ref(0)
  const isLoading = ref(false)

  const SHOW_DELAY = 0 // ms — не показываем, если запрос быстрее
  const MIN_DISPLAY = 100 // ms — минимальное время показа, если уже показали

  let showTimer: number | null = null
  let hideTimer: number | null = null

  function show () {
    activeLoaders.value++

    if (activeLoaders.value === 1) {
      // Первый лоадер → планируем показ через задержку
      if (showTimer === null) {
        showTimer = window.setTimeout(() => {
          isLoading.value = true
          showTimer = null

          // Если к этому моменту все закончились — сразу прячем
          if (activeLoaders.value === 0) {
            isLoading.value = false
          }
        }, SHOW_DELAY)
      }
    }
  }

  function hide () {
    if (activeLoaders.value <= 0) return
    activeLoaders.value--

    if (activeLoaders.value === 0) {
      // Если таймер показа ещё не сработал — отменяем показ вообще
      if (showTimer !== null) {
        clearTimeout(showTimer)
        showTimer = null
        return
      }

      // Лоадер уже виден → даём ему отжить минимум времени
      if (hideTimer === null) {
        hideTimer = window.setTimeout(() => {
          isLoading.value = false
          hideTimer = null
        }, MIN_DISPLAY)
      }
    }
  }

  function reset () {
    activeLoaders.value = 0
    if (showTimer) clearTimeout(showTimer)
    if (hideTimer) clearTimeout(hideTimer)
    showTimer = hideTimer = null
    isLoading.value = false
  }

  return {
    isLoading,
    show,
    hide,
    reset,
  }
})
